import { Nfc, MousePointerClick, Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "@/lib/site";

const STEPS = [
  {
    n: "01",
    icon: Nfc,
    color: "#4285F4",
    title: "Il cliente avvicina o inquadra",
    text: "Un tap NFC sul telefono o una scansione del QR code. Nessuna app da scaricare, nessuna registrazione: funziona con qualsiasi smartphone.",
  },
  {
    n: "02",
    icon: MousePointerClick,
    color: "#34A853",
    title: "Si apre la tua pagina Google",
    text: "La carta è collegata direttamente alla scheda recensioni della tua attività: il cliente atterra esattamente dove serve, in un secondo.",
  },
  {
    n: "03",
    icon: Star,
    color: "#FBBC04",
    title: "Cinque stelle in 3 secondi",
    text: "Il momento è quello giusto: il cliente è ancora nel tuo locale, soddisfatto. La recensione arriva spontanea, sincera e immediata.",
  },
];

export const HowItWorks = () => (
  <section id="come-funziona" data-testid="how-it-works" className="mx-auto max-w-6xl px-5 py-24 sm:py-32">
    <Reveal className="max-w-2xl">
      <span className="rounded-full bg-blue-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-[#4285F4]">
        Come funziona
      </span>
      <h2 className="font-display mt-5 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
        Da cliente felice a recensione pubblicata, in un gesto.
      </h2>
    </Reveal>

    <div className="mt-14 grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
      <Reveal delay={0.1} className="relative">
        <div className="pointer-events-none absolute -inset-6 rounded-[2.5rem] bg-gradient-to-br from-[#4285F4]/10 via-transparent to-[#FBBC04]/10" />
        <div className="relative overflow-hidden rounded-3xl border border-slate-200 shadow-2xl shadow-slate-900/10">
          <img src={IMAGES.stand} alt="Espositore da banco TapGoogle.com con QR code e chip NFC" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
        </div>
      </Reveal>

      <div className="flex flex-col gap-5">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={0.12 * i}>
            <div
              data-testid={`step-${s.n}`}
              className="group flex gap-5 rounded-3xl border border-slate-200 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#4285F4]/40 hover:shadow-xl hover:shadow-blue-500/10"
            >
              <div className="flex flex-col items-center gap-2">
                <span
                  className="flex h-12 w-12 items-center justify-center rounded-2xl transition-transform duration-300 group-hover:scale-110"
                  style={{ backgroundColor: `${s.color}1a`, color: s.color }}
                >
                  <s.icon className="h-6 w-6" />
                </span>
                <span className="font-display text-xs font-bold text-slate-300">{s.n}</span>
              </div>
              <div>
                <h3 className="font-display text-lg font-bold text-slate-900 sm:text-xl">{s.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-slate-600 sm:text-base">{s.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
